import { render, staticRenderFns } from "./Feedbacks.vue?vue&type=template&id=778cfaf1&scoped=true"
import script from "./Feedbacks.vue?vue&type=script&lang=ts"
export * from "./Feedbacks.vue?vue&type=script&lang=ts"
import style0 from "./Feedbacks.vue?vue&type=style&index=0&id=778cfaf1&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "778cfaf1",
  null
  
)

export default component.exports